import { state, props } from 'cerebral/tags'
import { set, when } from 'cerebral/operators'

// TODO: support search and latest files
export default [
  set(state`media.sortType`, props`sortType`),
  set(state`media.selectedFiles`, []),
  when(state`app.currentView`, view => view === 'media'),
  {
    true: [
      when(state`node.selectedNode.id`),
      {
        true: [set(props`id`, state`node.selectedNode.id`)],
        false: []
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/changeSortType.js